export default __webpack_public_path__ + "static/media/26.227fcfe0.png";